import * as THREE from "three";
import { toggleDoor } from "./doorAnimationStore";
import { setVisibleSpriteTextInObj } from "../helpers/setVisibleSpriteTextInObj";

// const targetSize =  { width: 1381, height: 922 }
const targetSize = { width: 1135, height: 1133 };

/**
 * Делает скриншот активных объектов на сцене ThreeJS.
 * @param {string} activeArrayName - имя массива в servObj, например "activeTableAnnex"
 * @param {{ width: number, height: number }} [currentSize] - размеры скриншота
 * @returns {Promise<string|null>} base64-строка изображения (jpeg) или null
 */
export async function makeObjectScreenshot(currentSize = targetSize) {
    const servObj = parent.servObj;

    if (!servObj) {
        console.warn("[screenshot.js] servObj не определен");
        return null;
    }

    return new Promise((resolve) => {
        const renderer = servObj.renderer;
        const camera = servObj.scene.activeCamera;
        const scene = servObj.scene;

        const hasUpSideElem = servObj.activeKomplektStoek.length > 0;

        const originalSize = { width: renderer.domElement.width, height: renderer.domElement.height };
        const originalAspect = camera.aspect;
        const originalPosition = camera.position.clone();
        const originalTarget = camera.target ? camera.target.clone() : null;
        const originalQuaternion = camera.quaternion.clone();
        const isStoyka = servObj.redactorModeObject.name.includes("stoyka");
        const isTumbaTS10 = servObj.redactorModeObject.name.includes("tumba__ts_10");
        const isTumba = servObj.redactorModeObject.name.includes("tumba__");
        const isStellazh = servObj.redactorModeObject.name.includes("stellazh");
        const isTableSMK = servObj.redactorModeObject.name.includes("smk__");
        const isTableSSU = servObj.redactorModeObject.name.includes("ssu__");
        const isWardrobe = servObj.redactorModeObject.userData.loadData.folderName === "wardrobes";

        servObj.active = null;
        servObj.building.restoreObjectColor();

        const activeObjects = Object.keys(servObj)
            .filter((key) => key.startsWith("active") && !key.includes("activeHitbox") && Array.isArray(servObj[key]))
            .map((key) => servObj[key])
            .flat();

        activeObjects.push(servObj.redactorModeObject);

        if (!activeObjects.length) {
            console.warn("[screenshot.js] activeObjects пустой");
            resolve(null);
            return;
        }

        let isDoorsOpen = false;
        const isVisibleSprites = servObj.redactorModeObject.children.find((el) => el.isSprite);

        if (isWardrobe) {
            if (!servObj.activeWardrobeDoors?.length) {
                return console.error("❌ Активные двери не найдены!");
            }

            const door = servObj.activeWardrobeDoors[0];
            const doorData = parent.__doorAnimationMap.get(door.name);
            if (!doorData) {
                console.error("❌ Дверь не инициализирована в doorAnimationMap!");
                return;
            }
            const { isOpen } = doorData;
            isDoorsOpen = isOpen;

            servObj.activeWardrobeDoors.forEach((obj) => {
                toggleDoor(obj, true, 0); // открываем двери без анимации
            });

            setVisibleSpriteTextInObj({ targetObject: servObj.redactorModeObject, visible: false });
        }

        const box = new THREE.Box3();
        activeObjects.forEach((obj) => box.expandByObject(obj));
        const size = box.getSize(new THREE.Vector3());
        const center = box.getCenter(new THREE.Vector3());

        renderer.setSize(currentSize.width, currentSize.height, false);
        camera.aspect = currentSize.width / currentSize.height;
        camera.updateProjectionMatrix();

        const maxDim = Math.max(size.x, size.y, size.z);
        const fov = (camera.fov * Math.PI) / 180;
        const diag = Math.sqrt(size.x * size.x + size.z * size.z);

        const extraDistance = () => {
            if (isStoyka) return 0.8;
            if (isTumbaTS10) return 0.8;
            if (isStellazh) return 0.8;
            if (isTableSMK) return 0.4;
            if (isWardrobe) return 0.7;
            return 0;
        };

        const distance = diag / 2 / Math.tan(fov / 2) + (hasUpSideElem ? 1.4 : 0.6) + extraDistance();

        let phi = THREE.MathUtils.degToRad(-30);
        if (isTableSSU) phi = THREE.MathUtils.degToRad(-65);
        if (isWardrobe) phi = THREE.MathUtils.degToRad(0);
        let camX = center.x + distance * Math.sin(phi);
        const camZ = center.z + distance * Math.cos(phi);
        let camY = hasUpSideElem ? center.y + maxDim * 0.3 : center.y + maxDim * 0.5;

        if (isTumba) {
            camY += maxDim * 0.3; // немного приподнимаем камеру для всех тумб
        }
        if (isTableSSU) {
            camY += maxDim * 0.3; // немного приподнимаем камеру для стола ССУ
        }
        if (isWardrobe) {
            camY -= maxDim * 0.3;
        }

        camera.position.set(camX, camY, camZ);
        camera.lookAt(center);

        renderer.render(scene, camera);
        const imgData = renderer.domElement.toDataURL("image/jpeg", 1.0);

        renderer.setSize(originalSize.width, originalSize.height, false);
        camera.aspect = originalAspect;
        camera.position.copy(originalPosition);
        camera.quaternion.copy(originalQuaternion);
        if (originalTarget && camera.target) camera.target.copy(originalTarget);
        camera.updateProjectionMatrix();

        if (isWardrobe) {
            servObj.activeWardrobeDoors.forEach((door) => {
                toggleDoor(door, isDoorsOpen, 0);
            });
            isVisibleSprites && setVisibleSpriteTextInObj({ targetObject: servObj.redactorModeObject, visible: true });
        }

        resolve(imgData);
    });
}
export function insertScreenShot(base64) {
    const iframe = document.getElementById("iframe");

    if (!iframe || !iframe.contentWindow) {
        console.error("Ошибка: iframe недоступен.");
        return;
    }

    const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

    const img = iframeDocument.createElement("img");
    img.src = base64;
    iframeDocument.getElementById("main_screenshot").innerHTML = "";
    iframeDocument.getElementById("main_screenshot").append(img);
}
